import TextSeasonsEpisodes from './TextSeasonsEpisodes'

export default TextSeasonsEpisodes
// eslint-disable-next-line import/export
export * from './TextSeasonsEpisodes'
